define([
	"dojo/_base/declare",
	"csi/reflection",
	"csi/heading/StringType"
], function(declare,reflection,StringType) {
	return declare(StringType, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			var	rc = reflection.getClass(ctx.getNode().$Name);
			return rc.getType();
		}
	});
});